module.exports = __webpack_public_path__ + "img/image118.05708c18.jpg";